import React, {createContext, useContext, useEffect, useState} from "react";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    // Try to get the language from localStorage on component mount
    const storedLanguage = localStorage.getItem("language") || "ar"; // default to "ar" if nothing is stored
    const [language, changeLanguage] = useState(storedLanguage);
    const [direction, setDirection] = useState(language === "ar" ? "rtl" : "ltr");

    // Update the dir attribute when the language changes
    useEffect(() => {
        // Update direction based on language
        const dir = language === "ar" ? "rtl" : "ltr";
        setDirection(dir);
        document.documentElement.setAttribute("dir", dir); // Set dir on <html>
        document.documentElement.setAttribute("lang", language); // Set lang on <html>

        // Save the selected language to localStorage
        localStorage.setItem("language", language);
    }, [language]);

    return (
        <LanguageContext.Provider value={{ direction, language, changeLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);
